import React from 'react'

import {
  ReactFlow,
  Background,
  BackgroundVariant,
  Controls,
  Edge,
  EdgeTypes,
  MiniMap,
  NodeTypes,
  OnConnect,
  OnEdgesChange,
  OnNodesChange
} from '@xyflow/react'
import NodeType from 'types/transformation/enums/NodeType'
import { Node } from 'types/transformation/types/nodes'

import Box from 'components_new/atoms/Box'

import { BOARD, getAccent } from 'components_new/molecules/Node/accents'

import '@xyflow/react/dist/style.css'
import '@xyflow/react/dist/base.css'

import './style.css'

interface DrawingBoardProps {
  editMode: boolean
  nodes: Node[]
  edges: Edge[]
  onNodesChange: OnNodesChange<Node>
  onEdgesChange: OnEdgesChange<Edge>
  onNodeDragStop?: () => void
  nodeTypes: NodeTypes
  edgeTypes: EdgeTypes
  onConnect: OnConnect
  className?: string
  sx?: object
}

const DrawingBoard = (props: DrawingBoardProps) => {
  const {
    nodes,
    edges,
    nodeTypes,
    edgeTypes,
    onConnect,
    editMode,
    onNodeDragStop,
    onNodesChange,
    onEdgesChange,
    sx
  } = props

  return (
    <Box
      className="sim-drawing-board"
      sx={{ bgcolor: BOARD.canvas, height: '100%', width: '100%' }}
    >
      <ReactFlow
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        onConnect={onConnect}
        elementsSelectable={editMode}
        nodesConnectable={editMode}
        nodesDraggable={editMode}
        selectNodesOnDrag={editMode}
        edgesFocusable={editMode}
        edgesReconnectable={editMode}
        onNodeDragStop={onNodeDragStop}
        fitView
        minZoom={0}
        proOptions={{ hideAttribution: true }}
        style={sx}
      >
        <Background
          color={BOARD.dots}
          gap={20}
          size={1.4}
          variant={BackgroundVariant.Dots}
        />
        <Controls showFitView showInteractive />
        <MiniMap
          maskColor="rgba(244, 244, 245, 0.7)"
          nodeBorderRadius={4}
          nodeColor={(node) => getAccent(node.type as NodeType).bg}
          nodeStrokeColor={(node) => getAccent(node.type as NodeType).stark}
          pannable
          zoomable
          style={{ height: 84, width: 130 }}
        />
      </ReactFlow>
    </Box>
  )
}

export default DrawingBoard
